module.exports = __webpack_public_path__ + "img/zoom_len.05d8f1e2.svg";